const styles = {
  esButton: {
    mr: 1,
  },
};

export default styles;
